export default __webpack_public_path__ + "static/media/bg.7a71d5d5.webp";